import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#BB5B34',
      light: '#D98F66',
      dark: '#8C3F22',
    },
    secondary: {
      main: '#6E5C4F',
    },
    background: {
      default: '#FAF6F1',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#2B2420',
      secondary: '#6F6259',
    },
    divider: '#E7DDD2',
    success: {
      main: '#4C7A50',
    },
    warning: {
      main: '#C08A2E',
    },
    error: {
      main: '#C4392B',
    },
    info: {
      main: '#8B5D6B',
    },
  },
  typography: {
    h3: {
      '@media (max-width:600px)': {
        fontSize: '1.75rem',
      },
    },
    h4: {
      '@media (max-width:600px)': {
        fontSize: '1.35rem',
      },
    },
    h5: {
      '@media (max-width:600px)': {
        fontSize: '1.15rem',
      },
    },
    h6: {
      '@media (max-width:600px)': {
        fontSize: '1rem',
      },
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          '@media (max-width:600px)': {
            fontSize: '0.8125rem',
            padding: '4px 12px',
          },
        },
        sizeLarge: {
          '@media (max-width:600px)': {
            fontSize: '0.875rem',
            padding: '6px 16px',
          },
        },
        sizeSmall: {
          '@media (max-width:600px)': {
            fontSize: '0.75rem',
            padding: '3px 9px',
          },
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          '@media (max-width:600px)': {
            fontSize: '1.125rem',
            padding: '12px 16px',
          },
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          '@media (max-width:600px)': {
            padding: '8px 16px',
          },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          '@media (max-width:600px)': {
            padding: '8px 16px 12px',
          },
        },
      },
    },
  },
});

export default theme;
